module.exports = __webpack_public_path__ + "img/local_pin.c5b37ad1.png";